import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import cartUtils from '../../../utils/cart';
import formatUSD from '../../../utils/formatUSD';
import ChromeFoldContext from '../layouts/ChromeFoldContext';
import { selectIncentiveProductsToTrack } from '../../../selectors';

const IncentiveTracker = () => {
  const selectedStudent = useSelector(
    (state) => state.additionalData.selectedStudent,
  );
  const shoot = useSelector((state) => state.shoot?.shoot);
  const shootEventId = shoot?.event_id || shoot?.id;
  const orders = useSelector((state) => state.v3Order.orders);
  const { folded } = useContext(ChromeFoldContext);

  // The active catalog's order-level incentives plus the cart-level union
  // across every price list in the cart (ENG-2965) — the "Earned: Free
  // Shipping" state must not flip depending on which school the parent
  // happens to be viewing.
  const productsToTrack = useSelector(selectIncentiveProductsToTrack);

  if (!selectedStudent) {
    return null;
  }
  // Nothing to track — return null so the V3Layout drops its reserved
  // top margin (the tracker is position:fixed with height:50px and would
  // otherwise leave a 100px gap above the page content).
  if (productsToTrack.length === 0) {
    return null;
  }

  const orderKey =
    shootEventId && selectedStudent?.id
      ? `${shootEventId}-${selectedStudent.id}`
      : null;
  const currentOrderCartItems =
    (orderKey ? orders[orderKey] : undefined)?.cartItems || [];
  const currentOrderTotal = cartUtils.getOrderTotal(currentOrderCartItems);
  const allOrdersTotal = cartUtils.getAllOrdersTotal(orders);
  const allCartSKUs = cartUtils.getAllCartSKUs(orders);

  const renderSections = () => {
    const widthStyle = {
      width: `${100 / productsToTrack.length}%`,
    };

    const sections = productsToTrack.map((product, i) => {
      let desktopText;
      let mobileTextTop;
      let mobileTextCenter;
      let mobileTextBottom;
      let diff;
      let cartLevelProductInCart = false;

      if (product.incentive_applies_to === 'cart_level') {
        diff = product.incentive_threshold - allOrdersTotal;
      } else if (product.incentive_applies_to === 'order_level') {
        diff = product.incentive_threshold - currentOrderTotal;
      }

      let className = 'incentive-tracker__section--unfilled';
      className += ` incentive-tracker__section--unfilled-${i + 1}`;

      const price = formatUSD(diff, true);

      if (
        diff <= 0 ||
        (product.incentive_applies_to === 'cart_level' &&
          allCartSKUs.includes(product.sku))
      ) {
        desktopText = `Earned: ${product.name}!`;
        mobileTextTop = 'Earned:';
        mobileTextCenter = `${product.name}`;
        mobileTextBottom = '!';
        className = 'incentive-tracker__section--filled';
        className += ` incentive-tracker__section--filled-${i + 1}`;
      } else {
        desktopText = `Spend ${price} more: ${product.name}`;
        mobileTextTop = `Spend ${price} more:`;
        mobileTextCenter = `${product.name}`;
      }

      const textClassName = 'incentive-tracker__section-text';
      const textCompanyClassName = '';
      const countclassName = `incentive-tracker__section--${productsToTrack.length}-total`;

      return (
        <li
          className={`incentive-tracker__section ${className}`}
          key={`incentive-tracker-section-${i}`}
          style={widthStyle}
        >
          <div
            className={`${textClassName} ${textClassName}--desktop ${textCompanyClassName} ${countclassName}`}
          >
            {desktopText}
          </div>
          <div
            className={`${textClassName} ${textClassName}--mobile ${textCompanyClassName}`}
          >
            <div>{mobileTextTop}</div>
            <div>{mobileTextCenter}</div>
            <div>{mobileTextBottom}</div>
          </div>
        </li>
      );
    });

    return sections;
  };

  return (
    <ul
      className={`incentive-tracker clearfix${
        folded ? ' incentive-tracker--folded' : ''
      }`}
    >
      {renderSections()}
    </ul>
  );
};

export default IncentiveTracker;
